export * from './components/products-dropdown';
export * from './components/products-dropdown/components';
export * from './components/query-badge';
export * from './components/query-item-content';
export * from './components/TaxonomyExplorer';
export * from './components/custom-table-layout';
export * from './components/TaxonomyExplorer/components/ItemInfoBox';
export * from './components/TaxonomySelector';
export * from './modules/free-trial';

export { useTabAppVisibilityChanged, useWindowSize } from './utils/hooks';
// Re-export constants from constants for backward compatibility
// TODO: Update all imports to use @discover-frontend/constants directly
export * from '@discover-frontend/constants';
